import React from 'react';
import cn from 'classnames';
import ddt from '@wix/da-ddt';
import { extConfigFullscreen } from '../../../Editor/presets/Commission/config';
import Viewer from '../../Viewer';
import s from './Commission.scss';
const logger = ddt.createLogger('tiptapeditor');
const CommissionViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref)=>{
    logger.log('CommissionViewer', {
        contentJson: JSON.stringify(contentJson),
        cookieType,
        defaultSize
    });
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "commission",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfigFullscreen,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
CommissionViewer.displayName = 'CommissionViewer';
export default CommissionViewer;

//# sourceMappingURL=Commission.js.map